"use strict";
/*
 *@modifyContent:  视频组件二次封装
 *@author: qiuhongyang
 *@date: 2020-08-01 12:58:04
 *
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var cookie_1 = __importDefault(require("../cookie"));
var changeimg_1 = __importDefault(require("../changeimg"));
var horselamp_1 = __importDefault(require("../horselamp"));
function smallPreventEvent(e) {
    var tlen = $(e.target).parent('#campany_media').length; //如果是小视频播放 不执行相关逻辑
    if (tlen)
        return;
}
/**
     * 加载小窗口视频
     * @param src
     */
function loadSmallVideo() {
    var isfirst = true;
    var narrow = function () {
        console.log("narrow");
        var vediodom = $("#ly_vedio_media");
        vediodom.children("div:first-child").css({
            "width": "300px", "height": "180px"
        });
        $("#smallvediowrap").show();
        $("#smallvediowrap").append(vediodom);
        $("#ly-close-small").remove();
        var closeele = $('<span id="ly-close-small" class="ly-close-small"></span>');
        vediodom.append(closeele);
        $(".emav-playback-rate").hide();
        $(".emav-fullscreen-control").hide();
    };
    var enlarge = function () {
        // console.log("enlarge")
        // let uid:any = cookie.get('uidal') || cookie.get('uid');
        //有文档直播小窗展示
        var vediodom = $("#ly_vedio_media");
        if ($("#ly_img_media").css("display") != 'none') {
            vediodom.css({
                "position": "", "width": "140px", "height": "90px", "margin-left": "15px"
            });
            vediodom.children("div:first-child").css({
                "width": "140px", "height": "90px"
            });
        }
        else {
            vediodom.css({
                "position": "static", "width": "650px", "height": "366px", "margin-left": ""
            });
            vediodom.children("div:first-child").css({
                "width": "650px", "height": "366px"
            });
        }
        ;
        $("#smallvediowrap").hide();
        $("#vedio-wrap").prepend($("#ly_vedio_media")); //不要直接append()
        $(".ly-close-small").remove();
        $(".emav-playback-rate").show();
        $(".emav-fullscreen-control").show();
    };
    $("#ly_vedio_media").on("click", "#ly-close-small", function () { isfirst = false; enlarge(); });
    $(window).scroll(lodash_1.default.debounce(function () {
        if (!isfirst)
            return false; // 音频
        var playstatus = sessionStorage.getItem("lyplaystatus");
        var showsmallvedio = sessionStorage.getItem("showsmallvedio");
        if (playstatus == "err" || showsmallvedio)
            return;
        var scrolltop = $(document).scrollTop();
        var vediowrap = $("#vedio-wrap").offset();
        var offsettop = vediowrap.top;
        var _h = $("#vedio-wrap").height();
        if ($("#zb_content").hasClass("blur-content"))
            return false;
        if (scrolltop - offsettop - _h > 50) {
            narrow();
        }
        else {
            enlarge();
        }
    }, 0));
}
;
function removeErrlab() {
    $("#ly-err-label").remove();
}
function showLeftTime() {
    $("#lefttime-wrap").show();
}
function hideLeftTime() {
    $("#lefttime-wrap").hide();
}
//播放错误
function playerrFun(videoitem, options, entype) {
    videoitem.poster("");
    // videoitem.src(options.src);
    $(".voice_play_mask").hide(); // 音频蒙层
    $(".voice_play_fullscreen_mask").hide();
    $(".emav-error-display").hide();
    $("#ly-img-wrap").css({ "display": "none" });
    removeErrlab();
    var errlab = $("<div id=\"ly-err-label\" class=\"ly-err-label\"></div>");
    $("#vedio-wrap").append(errlab);
    setTimeout(function () { $(".emav-loading-spinner").hide(); }, 1000);
}
/**
 *
 * @param data 文档直播
 */
function documentzb(data) {
    var _a, _b, _c, _d, _e;
    changeimg_1.default.init({
        boxid: "ly_img_media",
        imglist: ((_a = data === null || data === void 0 ? void 0 : data.doc_show_info) === null || _a === void 0 ? void 0 : _a.pages) ? (_b = data === null || data === void 0 ? void 0 : data.doc_show_info) === null || _b === void 0 ? void 0 : _b.pages : [],
        current_page: (_d = (_c = data === null || data === void 0 ? void 0 : data.doc_show_info) === null || _c === void 0 ? void 0 : _c.current_page) === null || _d === void 0 ? void 0 : _d.page,
        autoplay: (_e = data === null || data === void 0 ? void 0 : data.doc_show_info) === null || _e === void 0 ? void 0 : _e.autoplay
    });
}
/**
 * 直播: 1直播中  3回顾 4预告
 */
function loadZb(dataall) {
    setTimeout(function () {
        documentzb(dataall);
    }, 1500); //留一秒缓冲
}
;
/**
 * 直播加载滚动条
 * @param data
 */
function loadHorseLamp(data, rtcinfos) {
    var _a;
    $(".emav-bottom-tooltip").hide();
    // 正在直播 或者测试中
    if (data.status == 1 || (rtcinfos === null || rtcinfos === void 0 ? void 0 : rtcinfos.rtc_status) == 1) {
        var tooltip_config = (_a = data === null || data === void 0 ? void 0 : data.watermark_config) === null || _a === void 0 ? void 0 : _a.tooltip_config;
        if ((tooltip_config === null || tooltip_config === void 0 ? void 0 : tooltip_config.open) && (tooltip_config === null || tooltip_config === void 0 ? void 0 : tooltip_config.text)) {
            new horselamp_1.default({
                container: $(".emav-bottom-tooltip"),
                configinfo: tooltip_config
            });
            $(".emav-bottom-tooltip").show();
        }
    }
}
/**
 * 播放监听事件
 * @param videoitem
 * @param options
 */
function videoEvent(videoitem, options) {
    var roomtype = options.dataall.type; // 3音频
    videoitem.on('play', function (e) {
        console.log("v-play");
        try {
            var tlen = $(e.target).parent('#campany_media').length; //如果是小视频播放 不执行相关逻辑
            if (tlen)
                return;
            if (roomtype == 3) {
                $(".voice_play_mask").show(); // 音频蒙层
                $(".voice_play_mask").find(".wave_icon").show();
            }
            $("#ly-zbhg-label").remove();
            //预告或直播
            if (options.dataall.status == 4 || options.dataall.status == 1) {
                hideLeftTime();
            }
            ;
        }
        catch (error) {
            console.log(error);
        }
        // if (options.status == 3) {
        //     $(".emav-playback-rate").removeClass("emav-hidden");
        // };
    });
    videoitem.on('error', function (e) {
        console.log("v-err");
        try {
            var tlen = $(e.target).parent('#campany_media').length; //如果是小视频播放 不执行相关逻辑
            if (tlen)
                return;
            sessionStorage.setItem("lyplaystatus", "err");
            playerrFun(videoitem, options, 'error');
            $(".emav-error-display").hide();
            if (options.dataall.status == 1) {
                $("#ly_vedio_media .emav-big-play-button").hide();
            }
            ;
        }
        catch (error) {
        }
    });
    videoitem.on('canplay', function (e) {
        var tlen = $(e.target).parent('#campany_media').length; //如果是小视频播放 不执行相关逻辑
        try {
            if (tlen)
                return;
            console.log("v-canplay");
            removeErrlab();
            var uid = cookie_1.default.get('uidal');
            $(".emav-error-display").show();
            //直播
            if (options.dataall.status == 1 && !!uid) { //初始化直播且登陆
                loadZb(options.dataall);
                hideLeftTime();
            }
            sessionStorage.setItem("lyplaystatus", "success");
            // loadHorseLamp(options.dataall)
        }
        catch (error) {
        }
    });
    videoitem.on('pause', function (e) {
        console.log("v-pause");
        try {
            var tlen = $(e.target).parent('#campany_media').length; //如果是小视频播放 不执行相关逻辑
            if (tlen)
                return;
            if (roomtype == 3) {
                $(".voice_play_mask").find(".wave_icon").hide(); // 音频蒙层
            }
            // removeErrlab();
            //预告
            if (options.dataall.status == 4) {
                showLeftTime();
            }
            ;
        }
        catch (error) {
        }
    });
    videoitem.on('seeking', function (e) {
        console.log("v-seeking");
        try {
            var tlen = $(e.target).parent('#campany_media').length; //如果是小视频播放 不执行相关逻辑
            if (tlen)
                return;
            //预告
            if (options.dataall.status == 4) {
                hideLeftTime();
            }
            ;
        }
        catch (error) {
        }
    });
    // 全屏&退出全屏
    videoitem.on('fullscreenchange', function (e) {
        console.log("v-fullscreenchange");
        // $(".voice_play_mask").addClass("voice_play_fullscreen_mask")
        // 音频
        if (roomtype == 3) {
            // 退出全屏
            if ($(".voice_play_mask").hasClass("voice_play_fullscreen_mask")) {
                $(".voice_play_fullscreen_mask").remove();
            }
            // 进入全屏
            else {
                var clonemask = $(".voice_play_mask").clone().addClass("voice_play_fullscreen_mask");
                $(".emav-fullscreen").append(clonemask);
            }
        }
        loadHorseLamp(options.dataall, options.istest);
    });
}
;
function initvideo(opt) {
    var _a;
    if (!opt.src) {
        return false;
    }
    ;
    var defaultopt = {
        dataall: [],
        width: 650,
        height: 366,
        poster: "",
        env: "",
        muted: false,
        status: "",
        autoplay: false,
        bigPlayButton: true,
        scalable: false,
        playbackRateMenuButton: true,
        rtcinfos: {} // 是否是测试直播间
    };
    var options = $.extend({}, defaultopt, opt);
    var videoitem = emav(options.boxid, {
        width: options.width,
        height: options.height,
        controls: true,
        poster: options.poster,
        posterImage: true,
        autoplay: options.autoplay,
        useFWASFSApi: true,
        loop: false,
        muted: options.muted,
        preload: 'auto',
        playbackRates: [0.75, 1.0, 1.25, 1.5, 2.0],
        controlBar: {
            children: [
                "playToggle",
                "volumePanel"
            ],
            playToggle: true,
            volumePanel: true,
            remainingTimeDisplay: false,
            currentTimeDisplay: true,
            timeDivider: true,
            durationDisplay: true,
            progressControl: true,
            playbackRateMenuButton: options.playbackRateMenuButton,
            fullscreenToggle: true //是否显示全屏按钮
        },
        pausedView: {
            title: "",
            color: '',
            backgroundColor: "",
            fontSize: 1.8,
            fullscreenFontSize: 3.8
        },
        showContextMenu: false,
        showBigPlayButtonOnPaused: true,
        bigPlayButton: options.bigPlayButton,
        isAudio: false,
        bottomTooltip: {
            backgroundColor: ""
        },
        statistic: {
            activeTime: true
        },
        env: options.env, //环境切换，默认为正式环境(production)，测试环境（env）需手动指定
    });
    var src = (options.src).replace('http://', '//').replace('https://', '//');
    videoitem.src(src);
    //状态标签展示:预告状态 1直播中  3回顾 4预告
    var status = options.status;
    if (options.scalable && options.dataall.type != 3) {
        setTimeout(function () {
            loadSmallVideo();
        }, 100);
    }
    ;
    //播放器事件
    videoEvent(videoitem, options);
    // videoitem.autoplay(true);
    // videoitem.ready(function(){
    //     videoitem.autoplay(true);
    //     videoitem.muted(false);
    // })
    //直播
    var viewtype = (_a = options === null || options === void 0 ? void 0 : options.dataall) === null || _a === void 0 ? void 0 : _a.view_type; //白名单 默认不播放
    if (status == 1 && viewtype != 4) {
        //$(".emav-poster").get(0).click()
        setTimeout(function () { videoitem.play(); }, 0);
        // $(".emav-big-play-button").show();
        $(".emav-progress-control").hide();
        $(".emav-time-control").hide();
        var win = window;
        if (!!win.ActiveXObject || "ActiveXObject" in win) {
            setTimeout(function () { $("#vedio-wrap").find(".emav-poster").trigger("click"); }, 1500);
        }
    }
    ;
    if (status == 3 && viewtype != 4) {
        var win = window;
        if (!!win.ActiveXObject || "ActiveXObject" in win) {
            setTimeout(function () { $("#vedio-wrap").find(".emav-poster").trigger("click"); }, 1500);
        }
        else {
            setTimeout(function () { videoitem.play(); }, 500);
        }
    }
    ;
    loadHorseLamp(options.dataall, options.rtcinfos);
}
exports.default = initvideo;
//# sourceMappingURL=data:application/json;base64,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